import { render, staticRenderFns } from "./choujiang.vue?vue&type=template&id=17b10d4a&scoped=true&"
import script from "./choujiang.vue?vue&type=script&lang=js&"
export * from "./choujiang.vue?vue&type=script&lang=js&"
import style0 from "./choujiang.vue?vue&type=style&index=0&id=17b10d4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b10d4a",
  null
  
)

export default component.exports